/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Name_PlaceholderInputs */

const en_directory_submit_name_placeholder = /** @type {(inputs: Directory_Submit_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. ChatGPT`)
};

const zh_directory_submit_name_placeholder = /** @type {(inputs: Directory_Submit_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如 ChatGPT`)
};

/**
* | output |
* | --- |
* | "e.g. ChatGPT" |
*
* @param {Directory_Submit_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_name_placeholder = /** @type {((inputs?: Directory_Submit_Name_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Name_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_name_placeholder(inputs)
	return zh_directory_submit_name_placeholder(inputs)
});
export { directory_submit_name_placeholder as "directory.submit.name_placeholder" }